import { recordDay } from "../../../components/dailyHubModel";
export interface GrowthDiary {
  id: number;
  content: string;
  date: string;
  created_at: string;
  diary_type?: string;
  person_id?: number;
  person_name?: string;
  images?: { id: number; url: string }[];
}
export interface GrowthRecord {
  key: string;
  kind: "note" | "meal" | "exercise";
  title: string;
  content: string;
  day: string;
  time: string;
  label: string;
  diary?: GrowthDiary;
  images?: { id: number; url: string }[];
}
export const asRows = (data: any): any[] =>
  Array.isArray(data) ? data : Array.isArray(data?.results) ? data.results : [];
const titleFor = (text: string) => {
  const line = text.trim().split("\n")[0] || "一条记录";
  return line.length > 38 ? `${line.slice(0, 38)}…` : line;
};
const labels: Record<string, string> = {
  note: "笔记",
  mood: "情绪",
  fitness: "健身笔记",
  tech: "技术",
  grudge: "记仇",
  gratitude: "记恩",
};
export function growthRecords(
  diaries: GrowthDiary[],
  meals: any[],
  sessions: any[],
): GrowthRecord[] {
  const rows: GrowthRecord[] = [
    ...diaries.map((d) => ({
      key: `note:${d.id}`,
      kind: "note" as const,
      title: titleFor(d.content),
      content: d.content,
      day: recordDay(d.date || d.created_at),
      time: d.date || d.created_at,
      label: labels[d.diary_type || "note"] || "笔记",
      diary: d,
      images: d.images,
    })),
    ...meals.map((m) => ({
      key: `meal:${m.id}`,
      kind: "meal" as const,
      title: m.food_name || "饮食记录",
      content: `${m.food_name || "饮食记录"}\n${m.amount ? `${m.amount} 克 · ` : ""}${m.calories ?? 0} 千卡${m.note ? `\n\n${m.note}` : ""}`,
      day: recordDay(m.date),
      time: m.created_at || m.date,
      label:
        (
          {
            breakfast: "早餐",
            lunch: "午餐",
            dinner: "晚餐",
            snack: "加餐",
          } as Record<string, string>
        )[m.meal_type] || "饮食",
    })),
    ...sessions.map((s) => ({
      key: `exercise:${s.id}`,
      kind: "exercise" as const,
      title: s.title || s.exercise_type_label || "运动记录",
      content: `${s.exercise_type_label || "运动"} · ${s.duration_minutes ?? 0} 分钟${s.distance_km ? ` · ${s.distance_km} 公里` : ""}\n${s.intensity_label || ""}${s.note ? `\n\n${s.note}` : ""}`,
      day: recordDay(s.started_at),
      time: s.started_at,
      label: "运动",
    })),
  ];
  return rows
    .filter((r) => r.day)
    .sort(
      (a, b) =>
        b.day.localeCompare(a.day) ||
        (new Date(b.time).getTime() || 0) - (new Date(a.time).getTime() || 0) ||
        b.key.localeCompare(a.key),
    );
}
export function startOfWeek(day: Date): Date {
  const result = new Date(day);
  result.setHours(0, 0, 0, 0);
  result.setDate(result.getDate() - ((result.getDay() + 6) % 7));
  return result;
}
